import { CATEGORIES_KEYS_TO_ICONS } from '~~/constants/categoriesKeys';

export default (categoryKey: string): ValueOf<typeof CATEGORIES_KEYS_TO_ICONS> | null => {

  if (!CATEGORIES_KEYS_TO_ICONS[categoryKey]) {

    return null;
  
  }

  return `/icons/categories/${CATEGORIES_KEYS_TO_ICONS[categoryKey]}.svg`;

};
